import { computed } from 'vue'
import { validLength } from '../api/checker'

export default function ( oldPassword, newPassword1, newPassword2 ){

  const oldPasswordValidator = () =>{
	return validLength(1, 10, oldPassword.value)
  }
  
  const newPassword1Validator = () =>{
	return validLength(1, 10, newPassword1.value)
  }
  
  const newPassword2Validator = () =>{
	return validLength(1, 10, newPassword2.value)
  }
  
  const newPasswordMatchValidator =() =>{
    if( newPassword1.value == newPassword2.value ) return true
    else return false
  }
  
  const allValidator = () =>{
    var res = ( computed( oldPasswordValidator ).value )
    
    if( res ){
      res = ( computed( newPassword1Validator ).value )
    }
    
    if( res ){
      res = ( computed( newPassword2Validator ).value )
    }

    if( res ){
      res = ( computed( newPasswordMatchValidator ).value )
    }

    
    if( res ){
      return false
    }else{
      return true
    }
  }
  
  //computed�ɐݒ�
  //�e���ڂ̓��͂��ω������ۂɏ������N��
  //�S�`�F�b�N�͓o�^�{�^�������ۂɎg�p����
  const resOldPasswordVal = computed( oldPasswordValidator )
  const resNewPassword1Val = computed( newPassword1Validator )
  const resNewPassword2Val = computed( newPassword2Validator )
  const resNewPasswordMatchVal = computed( newPasswordMatchValidator )
  
  const resAllVal = computed( allValidator )
  
  
  //���Y���W���[�����񋟂���ϐ��A���\�b�h��錾
  return{
	resOldPasswordVal,
	resNewPassword1Val,
	resNewPassword2Val,
	resNewPasswordMatchVal,
	resAllVal
  }
}